import { render, staticRenderFns } from "./Materiels.vue?vue&type=template&id=4911c6a0&"
import script from "./Materiels.vue?vue&type=script&lang=js&"
export * from "./Materiels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports